import React, { PureComponent } from 'react';

class TitleAndInfo extends PureComponent {
  render() {
    const { title, children } = this.props;
    return (
      <div className="row border-bottom border-primary mb-2 py-1">
        <div className="col-6">
          <div className="row text-secondary">
            {title}
          </div>
        </div>
        <div className="col-6">
          <div className="row">
            <div style={{ wordWrap: "break-word", fontWeight: 500 }} className="w-100">
              {children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TitleAndInfo;
